import React, { useCallback, useMemo } from 'react';

import { useSelector } from 'react-redux';


const ChatHeader = ({ roomInfo, writerInfo={}, date }) => {
  const { room_name, room_profile_image, room_id, room_shortid } = roomInfo;
  const room_owner_id = roomInfo.owner_id;

  const activeRoomId = useSelector(state => state.chat.activeChannel.room_id);
  const inRoom = activeRoomId ? true : false;

  const defaultChannelProfile = `/static/images/default/channel.png`;
  const defaultUserProfile = `/static/images/default/user.png`;



  const moveChannel = useCallback(() => {
    window.open(`${process.env.REACT_APP_MOEME_OPENLINK_URL}/${room_shortid || room_id}`)
  }, [room_shortid, room_id]);


  const title = useMemo(()=>{
    if (!inRoom) {
      return room_name;
    }
    let suffix = '';
    const { owner_id, sender_name, staff_msg } = writerInfo;
    
    if (owner_id === room_owner_id) {
      suffix = '(방장)';
    } else if (staff_msg === '1') {
      suffix = '(스탭)';
    }
    return sender_name+suffix;
  },[inRoom, room_name, room_owner_id, writerInfo]);


  const domTime = useMemo(()=>{
    const time = new Date(date.substring(0, 19).replace(' ', 'T'));
    const hours = time.getHours();

    return (
      <p className="date">
        <span>{(time.getFullYear())}.{(time.getMonth() + 1)}.{time.getDate().toString().padStart(2, '0')}</span>
        <span>{hours < 12 ? '오전' : '오후'} {hours.toString().padStart(2, '0')}:{time.getMinutes().toString().padStart(2, '0')}</span>
      </p>
    )
  },[date]);


  const domProfile = useMemo(()=>{
    if (inRoom) {
      return (<img src={writerInfo.profile_image ? `${process.env.REACT_APP_FILE_API_URL}?type=12&userid=${writerInfo.owner_id}&roomid=${room_id}` : defaultUserProfile} alt={writerInfo.sender_name} />);
    }
    return (<img src={room_profile_image ? `${process.env.REACT_APP_FILE_API_URL}?type=7&serverfile=${room_profile_image}` : defaultChannelProfile} alt={room_name} />);
  },[defaultChannelProfile, defaultUserProfile, inRoom, room_name, room_profile_image, room_id, writerInfo]);

  return (
    <div className="info">
      <p className="pic">{domProfile}</p>
      <div className="group">
        <p className="title">{title}</p>
        {domTime}
      </div>
      {!inRoom ? <button type="button" onClick={moveChannel}>채널이동</button> : null}
    </div>
  )
}

export default ChatHeader;